import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { ConversationResponsesResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ConversationResponsesResponseDataSchema>>

type Options = {
  refetchInterval?: number
  onSuccess?: (data: Response) => void
}

export const conversationResponsesQuery = (id: string, options: Options = {}) => {
  return queryOptions({
    queryKey: ["conversations", id, "responses"],
    queryFn: async () => {
      const response = await axios.get<Response>(`/conversations/${id}/responses`)
      options.onSuccess?.(response.data)
      return response.data.data
    },
    refetchInterval: options.refetchInterval,
  })
}
